export type ServiceId = "shopify" | "shipstation" | "woocommerce" | "pim" | "d365" | "pbb" | "fg" | "fg-pbb";

/**
 * Collection of all service IDs that represent PBB (Printful by Beanz) integrations.
 *
 * Use this array whenever you need to determine whether a given service is
 * PBB-related, for example by checking if `service.id` is included here.
 */
export const pbbServices: ServiceId[] = ["pbb", "fg", "fg-pbb"];
export interface Service {
  id: ServiceId;
  type: "service";
  name: string;
  serviceType: "local" | "remote";
  developer: Developer;
  logoSvg?: string;
  authenticationType?: string;
  description?: string;
  authenticationFields?: AuthenticationField[];
  isDeleted?: boolean;
  installUrl?: string;
}

export interface Developer {
  name: string;
  url: string;
}

type AuthFieldLabel = "domain" | "accessToken" | "language";

interface AuthenticationFieldOption {
  label: AuthFieldLabel;
  value: string;
}

export interface AuthenticationField {
  name: string;
  label: AuthFieldLabel;
  type: string;
  value?: string;
  options?: AuthenticationFieldOption[];
  placeholder?: string;
  helper?: string;
}
